import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Store from './store'
import './main.css'
import Moment from 'moment'
import VueHotkey from 'v-hotkey'
import VueFileAgent from 'vue-file-agent'
import 'vue-file-agent/dist/vue-file-agent.css'
import './assets/tailwind.css'
import ImageUploader from 'vue-image-upload-resize'
import Vue2Editor from 'vue2-editor'

Vue.use(VueFileAgent)
Vue.config.productionTip = false
Vue.prototype.$moment = Moment
Vue.use(VueHotkey)
Vue.use(ImageUploader)
Vue.use(Vue2Editor)

new Vue({
	Moment,
	router,
	Store,
	render: (h)=> h(App),
}).$mount("#app")
